import { render } from "./DisplayInfo.vue?vue&type=template&id=9735afe6&scoped=true"
import script from "./DisplayInfo.vue?vue&type=script&lang=js"
export * from "./DisplayInfo.vue?vue&type=script&lang=js"

import "./DisplayInfo.vue?vue&type=style&index=0&id=9735afe6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9735afe6"]])

export default __exports__